<template>
  <vue-final-modal name="edit-product" v-bind="$attrs" v-slot="{close}"
    :classes="['vfm-container vfm-product', product && product.imageLarge && product.imageLarge.path ? 'vfm-product__with-image' : '']"  v-on="$listeners" content-class="modalBoxShadow">
    <div class="product_container scroll" v-if="product">
      <div class="product_image" v-if="product.imageLarge && product.imageLarge.path"
        :style="'background-image: url('+product.imageLarge.path+')'">
        <button class="product_image_back d-flex d-lg-none" @click="close">
          <i class="material-icons">arrow_back</i></button>
      </div>
      <div class="product_content">
        <div class="product_content_data scroll">

          <div class="insidePadding">

            <button class="product_image_back d-flex d-lg-none d-flex d-lg-none mb-1 justify-content-start px-0"
              v-if="!product.imageLarge || !product.imageLarge.path" @click="close"><i class="material-icons">arrow_back</i></button>
            <div class="data__header">
              <h4 class="font-weight-bold">{{product.name}}</h4>
              <button @click="close" class="d-none d-lg-flex"><i class="material-icons">close</i></button>
            </div>
            <span class="description">{{product.description}}</span>

          </div>

          <div class="productLine"></div>

          <product-options ref="optionSelector" :product="product" v-if="product.type === 'PRODUCT'" v-model="selectedOptions"/>

          <div v-if="product.type === 'BUNDLE'">
            <bundle-part 
              :bundle-part="bundlePart" 
              v-for="bundlePart in product.bundleParts" 
              :key="bundlePart.id"
              v-model="bundleSelections[bundlePart.id]"
              :external-error="bundleErrors[bundlePart.id]"
              @update="onBundlePartUpdate"/>
          </div>

          <div class="product-comment insidePadding">
            <label>Instructions spécifiques</label>
            <textarea v-model="comment" placeholder="Ajoutez vos allergies ou vos commentaires (plus de sauce, pas d'oignon...)" class="form-control"></textarea>
            <small>Si vous souffrez d'allergies alimentaires ou si vous suivez un régime alimentaire spécifique, veuillez prendre contact directement avec le restaurant avant de passer votre commande.</small>
          </div>

        </div>
        <div class="product_content_footer d-none d-lg-flex">

          <div class="product-quantity" v-if="cart.type !== 'on_site'">
            <button @click="quantity--" :disabled="quantity === 0"><i class="material-icons">remove</i></button>
            <span>{{quantity}}</span>
            <button @click="quantity++"><i class="material-icons">add</i></button>
          </div>

          <button class="product_cta product_cta_blue" style="gap:0;" @click="openCartTime"
                  v-if="showAvailabilityChanger">
            <div style="font-size: 80%;">Changer date de la commande</div>
            <small style="font-size: 67%;">Dispo. uniquement {{category.availability.text}}</small>
          </button>

          <button class="product_cta product_cta_red" @click="addToCartButton" :disabled="isLoading" v-else-if="quantity === 0">
            <div v-if="!isLoading">Supprimer du panier</div>
            <loader v-if="isLoading"></loader>
          </button>

          <button class="product_cta" @click="addToCartButton" :disabled="isLoading" v-else-if="quantity > 0">
            <loader v-if="isLoading"></loader>
            <div class="addToCart" v-if="!isLoading">Modifier le panier</div>
            <div class="price" v-if="!isLoading">{{totalProductPrice}}</div>
          </button>

        </div>
      </div>
    </div>
    <div class="product_content_footer d-lg-none">

      <div class="product-quantity" v-if="cart.type !== 'on_site'">
        <button @click="quantity--" :disabled="quantity === 0"><i class="material-icons">remove</i></button>
        <span>{{quantity}}</span>
        <button @click="quantity++"><i class="material-icons">add</i></button>
      </div>

      <button class="product_cta product_cta_blue" @click="openCartTime"
              v-if="showAvailabilityChanger">
        <span>Changer de date pour modifier</span>
      </button>

      <button class="product_cta product_cta_red" @click="addToCartButton" :disabled="isLoading" v-else-if="quantity === 0">
        <span v-if="!isLoading">Supprimer du panier</span>
        <loader v-if="isLoading"></loader>
      </button>

      <button class="product_cta" @click="addToCartButton" :disabled="isLoading" v-else>
        <loader v-if="isLoading"></loader>
        <span v-if="!isLoading">Modifier le panier</span>
        <small class="price"  v-if="!isLoading">{{totalProductPrice}}</small>
      </button>


    </div>
  </vue-final-modal>
</template>

<style lang="scss">
.productLine {
  height: 3px;
  width: 100%;
  background-color: #F0F0F0;
}
.insidePadding {
  padding: 20px;
}
</style>

<script>
import {mapActions, mapGetters} from "vuex";
import {$vfm} from "vue-final-modal";
import ProductOptions from '@/components/Product/ProductOptions.vue';
import BundlePart from "@/components/Product/BundlePart.vue";
import CartTime from "@/components/Modals/Cart/CartTime.vue";

export default {
  name: 'EditProduct',
  components: {BundlePart, ProductOptions},
  props: {
    cartProduct: {
      required: true
    }
  },
  data(){
    return {
      selectedOptions: [],
      bundleSelections: {},
      selectedBundles: [], // Format compatible avec l'app
      bundleErrors: {}, // Pour stocker les erreurs de validation par bundlePart
      product: false,
      isLoading: false,
      quantity: 1,
      comment: '',
      category: null
    }
  },
  methods: {
    ...mapActions(['updateCartProduct']),

    openCartTime(){
      this.$root.$emit('openOrderTime', {next:this.category.availability.availableTimestamp});
    },

    onBundlePartUpdate(bundlePartData) {
      // Cette fonction est appelée quand un bundlePart est mis à jour
      // bundlePartData contient: { bundlePart, selection }
      console.log('Bundle part updated:', bundlePartData);
      
      // Clear error for this bundle part when user makes changes that could fix the error
      const bundlePart = bundlePartData.bundlePart;
      const selection = bundlePartData.selection;
      const currentError = this.bundleErrors[bundlePart.id];
      
      if (currentError && selection.length > 0) {
        // Check if the new selection fixes the error
        let errorFixed = false;
        
        if (bundlePart.required && bundlePart.min > 0 && selection.length >= bundlePart.min) {
          errorFixed = true;
        }
        if (selection.length <= bundlePart.max) {
          errorFixed = true;
        }
        
        // Check if modifier errors are fixed
        if (currentError.includes('options obligatoires')) {
          let allModifiersValid = true;
          for (let item of selection) {
            if (item.bundlePartItem && item.bundlePartItem.product && item.bundlePartItem.product.options && item.bundlePartItem.product.avaible) {
              const requiredOptions = item.bundlePartItem.product.options.filter(option => option.minSelect > 0);
              if (requiredOptions.length > 0) {
                const itemModifiers = item.modifiers || [];
                for (let requiredOption of requiredOptions) {
                  const optionModifiers = itemModifiers.find(mod => mod.id === requiredOption.id);
                  if (!optionModifiers || !optionModifiers.values || optionModifiers.values.length === 0) {
                    allModifiersValid = false;
                    break;
                  }
                  const totalSelected = optionModifiers.values.reduce((sum, value) => sum + (value.quantity || 0), 0);
                  if (totalSelected < requiredOption.minSelect) {
                    allModifiersValid = false;
                    break;
                  }
                }
                if (!allModifiersValid) break;
              }
            }
          }
          if (allModifiersValid) {
            errorFixed = true;
          }
        }
        
        if (errorFixed) {
          this.$set(this.bundleErrors, bundlePart.id, null);
        }
      }
      
      // Convertir les données vers le format compatible avec l'app
      this.updateBundleSelected(bundlePartData.selection, bundlePartData.bundlePart.id);
    },

    updateBundleSelected(bundleData, bundlePartId) {
      // Logic inspirée de AppProductModal.vue
      if (bundleData.length === 0) {
        this.selectedBundles = this.selectedBundles.filter(s => s.bundlePart.id !== bundlePartId);
        return;
      }

      // Remove existing entries for this bundle part
      this.selectedBundles = this.selectedBundles.filter(s => s.bundlePart.id !== bundlePartId);
      // Add new entries
      this.selectedBundles.push(...bundleData);
    },

    validateBundleSelections() {
      if (!this.product.bundleParts) return true;
      
      // Clear existing errors
      this.bundleErrors = {};
      let hasErrors = false;
      
      for (let bundlePart of this.product.bundleParts) {
        const selections = this.bundleSelections[bundlePart.id] || [];
        
        // Check minimum requirements
        if (bundlePart.required && bundlePart.min > 0) {
          if (selections.length < bundlePart.min) {
            this.$set(this.bundleErrors, bundlePart.id, `Veuillez sélectionner au moins ${bundlePart.min} élément(s)`);
            hasErrors = true;
            continue; // Skip other checks for this bundle part
          }
        }
        
        // Check maximum limits
        if (selections.length > bundlePart.max) {
          this.$set(this.bundleErrors, bundlePart.id, `Vous ne pouvez sélectionner que ${bundlePart.max} élément(s) maximum`);
          hasErrors = true;
          continue; // Skip other checks for this bundle part
        }
        
        // Check for required modifiers on selected items
        for (let selection of selections) {
          if (selection.bundlePartItem && selection.bundlePartItem.product && selection.bundlePartItem.product.options && selection.bundlePartItem.product.avaible) {
            const requiredOptions = selection.bundlePartItem.product.options.filter(option => option.minSelect > 0);
            if (requiredOptions.length > 0) {
              const selectionModifiers = selection.modifiers || [];
              
              // Check if all required options have selections
              let missingRequiredOptions = false;
              for (let requiredOption of requiredOptions) {
                const optionModifiers = selectionModifiers.find(mod => mod.id === requiredOption.id);
                if (!optionModifiers || !optionModifiers.values || optionModifiers.values.length === 0) {
                  missingRequiredOptions = true;
                  break;
                }
                
                // Check if minimum selections are met
                const totalSelected = optionModifiers.values.reduce((sum, value) => sum + (value.quantity || 0), 0);
                if (totalSelected < requiredOption.minSelect) {
                  missingRequiredOptions = true;
                  break;
                }
              }
              
              if (missingRequiredOptions) {
                this.$set(this.bundleErrors, bundlePart.id, `Veuillez sélectionner les options obligatoires pour ${selection.bundlePartItem.product.name}`);
                hasErrors = true;
                break; // Exit the selection loop for this bundle part
              }
            }
          }
        }
      }
      
      return !hasErrors;
    },

    convertToServerFormat(selectedBundles) {
      // Convert selectedBundles to the expected server format
      const serverFormat = [];
      
      selectedBundles.forEach(bundle => {
        serverFormat.push({
          bundlePart: bundle.bundlePart,
          bundlePartItem: bundle.bundlePartItem,
          product: bundle.product,
          modifiers: bundle.modifiers || [],
          quantity: bundle.quantity || 1,
          supplementPrice: bundle.supplementPrice || 0
        });
      });
      
      return serverFormat;
    },

    addToCartButton(){
      // Delete product
      if(this.quantity === 0){
        this.isLoading = true;
        this.updateCartProduct({
          options: [],
          comment: this.comment,
          productId: this.product.id,
          cartProductId: this.cartProduct.id,
          quantity: this.quantity
        })
            .then(() => {
              this.isLoading = false;
              $vfm.hide('edit-product');
            });
        return;
      }

      // Validate based on product type
      let validationPassed = true;
      
      if (this.product.type === 'PRODUCT') {
        validationPassed = this.$refs.optionSelector.validateFields();
      } else if (this.product.type === 'BUNDLE') {
        // Validate bundle selections
        validationPassed = this.validateBundleSelections();
      }

      if(validationPassed){
        const optionFlat = [];
        this.selectedOptions.forEach(option => {
          option.values.forEach((value) => {
            optionFlat.push({
              optionId: option.id,
              valueId: value.id,
              quantity: value.quantity
            });
          })
        });

        this.isLoading = true;
        
        if (this.product.type === 'PRODUCT') {
          // Update regular product in cart
          this.updateCartProduct({
            options: optionFlat,
            comment: this.comment,
            productId: this.product.id,
            cartProductId: this.cartProduct.id,
            quantity: this.quantity
          })
          .then(() => {
            this.isLoading = false;
            $vfm.hide('edit-product');
          });
        } else if (this.product.type === 'BUNDLE') {
          // Convert selectedBundles back to server format
          const bundleItemsForServer = this.convertToServerFormat(this.selectedBundles);
          
          // Update bundle in cart
          this.updateCartProduct({
            options: optionFlat,
            bundleItems: bundleItemsForServer,
            comment: this.comment,
            productId: this.product.id,
            cartProductId: this.cartProduct.id,
            quantity: this.quantity,
            type: 'BUNDLE'
          })
          .then(() => {
            this.isLoading = false;
            $vfm.hide('edit-product');
          });
        }

      }
      else{
        if (this.product.type === 'PRODUCT' && this.$refs.optionSelector) {
          const errorOptionIds = this.$refs.optionSelector.getOptionErrorIds();
          if (errorOptionIds.length > 0) {
            document.getElementById('option-'+errorOptionIds[0])
                .scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['cart', 'merchant', 'menu']),
    getCurrentPrice(){
      let price = this.product.priceDelivery;
      if(this.cart.type === 'delivery'){
        return this.product.priceDelivery;
      }
      if(this.cart.type === 'pickup'){
        return this.product.pricePickup;
      }
      if(this.cart.type === 'onsite' || this.cart.type === 'on_site_counter'){
        return this.product.priceOnsite;
      }
    },
    showAvailabilityChanger(){
      return this.category && this.category.availability && !this.category.availability.available;
    },
    totalProductPrice(){
      if(!this.getCurrentPrice){
        return false;
      }
      
      let totalPrice = this.getCurrentPrice.value;
      
      if (this.product.type === 'PRODUCT') {
        // Prix des options pour les produits normaux
        const optionTotalValues = this.selectedOptions.reduce((bigsum, o) => bigsum + o.values.reduce((sum, v) => sum + v.price * v.quantity, 0), 0);
        totalPrice += optionTotalValues;
      } else if (this.product.type === 'BUNDLE') {
        // Prix des bundles
        totalPrice += this.currentBundlePrice;
      }
      
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(
        totalPrice * this.quantity / 100
      );
    },
    
    currentBundlePrice() {
      if (this.selectedBundles.length === 0) return 0;

      // Bundle part supplement price
      const allBundleParts = Array.from(new Set(this.selectedBundles.map(b => b.bundlePart.id)));
      let bundlePartSupplementPrice = 0;
      if (allBundleParts.length > 0) {
        bundlePartSupplementPrice = allBundleParts.reduce((acc, bundlePartId) => {
          const bundlePart = this.product.bundleParts.find(b => b.id === bundlePartId);
          if (!bundlePart || !bundlePart.supplementPrice) return acc;
          return acc + bundlePart.supplementPrice.value;
        }, 0);
      }

      // Bundle part item supplement price
      const bundlePartItemSupplementPrice = this.selectedBundles.reduce((acc, item) => {
        return acc + (item.supplementPrice || 0);
      }, 0);

      // Modifier price for bundle items
      const bundlePartModifierPrice = this.selectedBundles
          .filter(b => b.modifiers && b.modifiers.length > 0)
          .reduce((acc, item) => {
            return acc + item.modifiers.reduce((acc2, modifier) => {
              return acc2 + modifier.values.reduce((acc3, value) => {
                return acc3 + (value.price * value.quantity);
              }, 0);
            }, 0);
          }, 0);

      return bundlePartItemSupplementPrice + bundlePartSupplementPrice + bundlePartModifierPrice;
    }
  },
  watch: {
    menu(){
      this.category = this.menu.find(m => m.id === this.product.categoryId);
    }
  },
  mounted() {
    this.product = this.cartProduct.product;
    this.category = this.menu.find(m => m.id === this.product.categoryId);
    this.quantity = this.cartProduct.quantity;
    this.comment = this.cartProduct.comment;
    
    // Initialize bundle selections if product is a bundle
    if (this.product.type === 'BUNDLE' && this.product.bundleParts) {
      this.product.bundleParts.forEach(bundlePart => {
        this.$set(this.bundleSelections, bundlePart.id, []);
        this.$set(this.bundleErrors, bundlePart.id, null);
      });
      
      // Load existing bundle selections from cart product
      if (this.cartProduct.bundleItems && Array.isArray(this.cartProduct.bundleItems)) {
        // Convert cartProduct.bundleItems format to component format
        this.selectedBundles = [];
        
        this.cartProduct.bundleItems.forEach(bundleItemGroup => {
          const bundlePart = bundleItemGroup.bundlePart;
          const selectedItems = bundleItemGroup.selectedItems || [];
          
          selectedItems.forEach(selectedItem => {
            const bundlePartItem = selectedItem.bundlePartItem;
            const modifierGroups = selectedItem.modifierGroups || [];
            
            // Convert modifierGroups to the format expected by BundlePart component
            const modifiers = [];
            modifierGroups.forEach(modGroup => {
              const modifierGroup = modGroup.modifierGroup;
              const groupModifiers = modGroup.modifiers || [];
              
              if (groupModifiers.length > 0) {
                modifiers.push({
                  id: modifierGroup.id,
                  values: groupModifiers.map(mod => ({
                    id: mod.modifier.id,
                    quantity: mod.quantity,
                    checked: true,
                    price: mod.modifier.price_wt || 0
                  }))
                });
              }
            });
            
            // Create bundle selection in the expected format
            const bundleSelection = {
              bundlePart: bundlePart,
              bundlePartItem: {
                id: bundlePartItem.id,
                product: {
                  id: bundlePartItem.product_id,
                  name: bundlePartItem.product_name,
                  // Add other product properties as needed
                }
              },
              product: {
                id: bundlePartItem.product_id,
                name: bundlePartItem.product_name,
              },
              modifiers: modifiers,
              quantity: selectedItem.quantity || 1,
              supplementPrice: parseInt(bundlePartItem.supplement_price_wt || 0)
            };
            
            this.selectedBundles.push(bundleSelection);
            
            // Initialize bundleSelections for v-model
            if (!this.bundleSelections[bundlePart.id]) {
              this.$set(this.bundleSelections, bundlePart.id, []);
            }
            this.bundleSelections[bundlePart.id].push(bundleSelection);
          });
        });
      }
    }
  }
}
</script>
